import { getHours } from "date-fns";
import { set } from "lodash";
import { numericFormatter } from "react-number-format";
import { PEAK_HOURS_CONFIG } from "../../constants";

export const isPeakTime = (date) => {
  const startHour = getHours(date);
  return startHour >= PEAK_HOURS_CONFIG.start && startHour < PEAK_HOURS_CONFIG.end;
};

export const prettifyStatusLabel = (status) => status.charAt(0).toUpperCase() + status.slice(1);

export const convertTimestampToDate = (date) => new Date(date?._seconds * 1000).toISOString();

export const validateSchema = (schema, data) => {
  return new Promise((resolve) => {
    if (!schema) resolve({});

    schema
      .validate(data, { abortEarly: false })
      .then(() => resolve({}))
      .catch((error) => {
        resolve(
          error.inner.reduce((prev, { message, path }) => {
            return set(prev, path, message);
          }, {})
        );
      });
  });
};

export const formatBytes = (kiloBytes, decimals) => {
  if (kiloBytes === 0) return ["0", "KB"];

  const k = 1024;
  const dm = decimals + 1 || 1;
  const sizes = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(kiloBytes) / Math.log(k));

  return [parseFloat((kiloBytes / k ** i).toFixed(dm)).toLocaleString(), sizes[i]].join(" ");
};

export const formatPrice = (price, prefix = "", suffix = "") => {
  return numericFormatter(Number(price).toString(), { prefix, thousandSeparator: true, displayType: "text", suffix });
};
